import { TAnalyticProductOptions } from './types';

export class AnalyticProduct {
    id = '';
    name = '';
    price = '';
    brand = '';
    category = '';
    variant = '';
    position = '';
    listName = '';
    currency = '';
    quantity? = '';

    constructor({ id, name, price, brand, category, variant, position, listName, currency, quantity }: TAnalyticProductOptions) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.brand = brand;
        this.category = category;
        this.variant = variant;
        this.position = position;
        this.listName = listName;
        this.currency = currency;
        this.quantity = quantity;
    }
}
